import { useRef } from "react";
import JobZImage from "../../../../common/jobz-img";
import { NavLink } from "react-router-dom";
// import { candidate, canRoute } from "../../../../../globals/route-names";
import { loadScript, publicUrlFor } from "../../../../../globals/constants";
import CountUp from "react-countup";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { publicUser } from "../../../../../globals/route-names";
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import HCaptcha from "@hcaptcha/react-hcaptcha";

const colors = [
    "#E63946", // red
    "#457B9D", // blue-gray
    "#2A9D8F", // teal
    "#F4A261", // orange
    "#264653", // deep teal
    "#8E44AD", // purple
    "#D7263D", // crimson
    "#3A86FF", // vivid blue
    "#06D6A0", // mint green
    "#FFBE0B", // yellow
    "#8338EC", // violet
    "#FF006E", // pink
    "#118AB2", // bright blue
    "#073B4C", // dark navy
    "#F77F00", // deep orange
    "#38B000", // green
    "#7209B7", // purple
    "#FF7F50", // coral
    "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}

function EmployerContactUs() {
    const { t } = useTranslation();
    const formRef = useRef(null);
    const profileRef = useRef(null);
    const captchaRef = useRef(null);
    const fileInputRef = useRef(null);

    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imgError, setImgError] = useState(false);
    const [file, setFile] = useState(null);
    const [captchaToken, setCaptchaToken] = useState(null);

    const [formData, setFormData] = useState({
        Name: "",
        companyName: "",
        EmpEmail: "",
        EmpNumber: "",
        Industry: "",
        JobTitle: "",
    });

    useEffect(() => {
        loadScript("js/custom.js")
        const fetchCandidates = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/candidate-list`); // Replace with your API endpoint
                const candidateData = response.data.data.filter(
                    (user) => user.role === "candidate"
                );
                const shuffled = candidateData.sort(() => 0.5 - Math.random());
                setCandidates(shuffled.slice(0, 8));
                setLoading(false);
            } catch (err) {
                if (err.response?.data?.message) {
                    setError(err.response.data.message);
                } else {
                    setError("Failed to load candidates. Please try again later.");
                }
                setLoading(false);
            }
        };
        fetchCandidates();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === "checkbox") {
            setFormData({ ...formData, [name]: checked });
        } else if (type === "file") {
            setFile(files[0]);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { Name, companyName, EmpEmail, EmpNumber, Industry, JobTitle } = formData;

        if (!Name || !companyName || !EmpEmail || !EmpNumber || !Industry || !JobTitle) {
            toast.error("Please fill in all fields.");
            setFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = null; // Clear file input
            }
            return;
        }

        if (!file) {
            toast.error("Please upload a job description file.");
            return;
        }

        if (!captchaToken) {
            toast.error("Please complete the CAPTCHA.");
            return;
        }

        const data = new FormData();
        data.append("Name", formData.Name);
        data.append("companyName", formData.companyName);
        data.append("EmpEmail", formData.EmpEmail);
        data.append("EmpNumber", formData.EmpNumber);
        data.append("Industry", formData.Industry);
        data.append("JobTitle", formData.JobTitle);
        if (file) {
            data.append("file", file);
        }

        try {
            const response = await axiosInstance.post(`${API_URL}/admin/employerCreateRequest`, data);
            console.log("Success:", response.data);
            toast.success("Form submitted successfully!");

            setFormData({
                Name: "",
                companyName: "",
                EmpEmail: "",
                EmpNumber: "",
                Industry: "",
                JobTitle: "",
            });
            setFile(null);
            setCaptchaToken(null);
            captchaRef.current?.resetCaptcha();
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);

            if (error.response?.status === 409) {
                toast.error("Email already exists.");
            } else {
                toast.error(error?.response?.data?.message || "Submission failed!");
            }
        }
    };

    return (
        <>
            <Helmet>
                <title>Employer | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            {/*Banner Start*/}
            <div className="twm-home-9-banner-section" style={{ backgroundImage: `url(${publicUrlFor("images/home-9/banner-bg/pic1.jpg")})`, marginTop: '90px' }}>
                <div className="container">
                    <div className="row">
                        {/*Left Section*/}
                        <div className="col-xl-7 col-lg-12 col-md-12">
                            <div className="twm-bnr-left-section">
                                <div className="twm-bnr-title-large">
                                    <span>{t("Thousands of skilled workers are waiting for you across borders.")}</span>
                                </div>
                                <button type="button" className="site-button" onClick={() => formRef.current.scrollIntoView({ behavior: 'smooth' })}>
                                    {t("Recruit Them !")}
                                </button>
                                <button type="button" className="ms-3 white site-button" onClick={() => profileRef.current.scrollIntoView({ behavior: 'smooth' })}>
                                    {t("Candidate profiles")}
                                </button>
                            </div>
                        </div>
                        {/*right Section*/}
                        <div className="col-xl-5 col-lg-12 col-md-12 twm-bnr-right-section">
                            <div className="twm-bnr-right-content">
                                <div className="bnr-media">
                                    {/* <JobZImage src="images/home-4/employee.png" alt="#" /> */}
                                    {/* <JobZImage src="images/home-6/featured-jobs/large-pic-1.png" alt="#" /> */}
                                    {/* <JobZImage src="images/home-6/banner-pic.png" alt="#" /> */}
                                    <JobZImage src="images/home-6/get-job-pic.png" alt="#" />
                                </div>
                                <div className="slider-thumb-wrap">
                                    <div className="slider-thumb" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*Banner End*/}
            {/* ABOUT SECTION START */}
            <div className="section-full p-t120 p-b90 twm-about-8-area">
                <div className="container">
                    <div className="twm-about-9-section-wrap">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 d-none d-md-block">
                                <div className="twm-about-9-section">
                                    <div className="twm-media">
                                        <JobZImage src="images/home-9/pic1.png" alt="" />
                                    </div>
                                    <div className="img-bg-circle" />
                                    {/*icon-block-2*/}
                                    <div className="twm-card-blocks-2 bounce2">
                                        <div className="twm-pics">
                                            <span><JobZImage src="images/main-slider/slider2/user/u-1.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-2.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-3.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-4.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-5.jpg" alt="" /></span>
                                            <span><JobZImage src="images/main-slider/slider2/user/u-6.jpg" alt="" /></span>
                                        </div>
                                        <div className="twm-content">
                                            <div className="tw-count-number text-clr-green">
                                                <span className="counter">
                                                    <CountUp end={3} duration={10} />
                                                </span>K+
                                            </div>
                                            <p className="icon-content-info">{t("Jobs Done")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="twm-about-9-section-right">
                                    {/* title="" START*/}
                                    <div className="section-head left wt-small-separator-outer">
                                        <div className="wt-small-separator site-text-primary">
                                            {/* <div>About </div> */}
                                        </div>
                                        <h2 className="wt-title">{t("Why choose us?")}</h2>
                                    </div>
                                    {/* title="" END*/}
                                    <ul className="description-list">
                                        <li>
                                            <i className="feather-check" />
                                            {t("Access to a larger pool of quality candidates")}
                                        </li>
                                        <li>
                                            <i className="feather-check" />
                                            {t("Diverse skills and cultural backgrounds")}
                                        </li>
                                        <li>
                                            <i className="feather-check" />
                                            {t("Better retention for the company")}
                                        </li>
                                        <li>
                                            <i className="feather-check" />
                                            {t("Alleviating skilled labor shortages")}
                                        </li>
                                    </ul>
                                    <div className="twm-about-1-bottom-wrap">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                {/*icon-block-1*/}
                                                <div className="twm-card-blocks">
                                                    <div className="twm-icon pink">
                                                        <JobZImage src="images/main-slider/slider2/icon-2.png" alt="" />
                                                    </div>
                                                    <div className="twm-content">
                                                        <div className="tw-count-number text-clr-pink">
                                                            <span className="counter">
                                                                <CountUp end={6} duration={1} />
                                                            </span>K+
                                                        </div>
                                                        <p className="icon-content-info">{t("Candidates")} </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                {/*icon-block-3*/}
                                                <div className="twm-card-blocks">
                                                    <div className="twm-icon">
                                                        <JobZImage src="images/main-slider/slider2/icon-1.png" alt="" />
                                                    </div>
                                                    <div className="twm-content">
                                                        <div className="tw-count-number text-clr-sky">
                                                            <span className="counter">
                                                                <CountUp end={5} duration={1} />
                                                            </span>K+
                                                        </div>
                                                        <p className="icon-content-info">{t("Happy Candidates")}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* CANDIDATES START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-candidate-h-page7-wrap pos-relative" ref={profileRef}>
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        {/* <div className="wt-small-separator site-text-primary">
                            <div>Candidates</div>
                        </div> */}
                        <h2 className="wt-title">{t("Candidate profiles")}</h2>
                    </div>
                    {/* title="" END*/}
                </div>
                <div className="container-fluid">
                    <div className="section-content">
                        <div className="twm-candidate-h-page7">
                            {loading ? (
                                <div className="text-center">Loading candidates...</div>
                            ) : error ? (
                                <div className="text-danger text-center">{error}</div>
                            ) : candidates.length === 0 ? (
                                <div className="text-center">No candidates found.</div>
                            ) : (
                                <div className="row d-flex justify-content-center m-b30">
                                    {candidates.map((candidate) => (
                                        <div
                                            key={candidate.id}
                                            className="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                                        >
                                            <div className="twm-candidates-grid-h-page7 m-b30">
                                                <div className="twm-top-section-content">
                                                    <div className="twm-media">
                                                        <div className="twm-media-pic">
                                                            <span>
                                                                {/* {candidate?.photo_url && !imgError ? (
                                                                    <img
                                                                        src={candidate.photo_url}
                                                                        alt="Profile"
                                                                        className="w-full h-auto rounded-full"
                                                                        onError={() => setImgError(true)}
                                                                    />
                                                                ) : ( */}
                                                                <div
                                                                    className="w-full h-auto rounded-full"
                                                                    style={{
                                                                        minWidth: "50px",
                                                                        backgroundColor: getRandomColor(candidate?.first_name?.[0]?.toUpperCase() || "A"),
                                                                        fontSize: "45px",
                                                                        fontWeight: "600",
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    {candidate?.first_name
                                                                        ? `${candidate.first_name[0]}`.toUpperCase()
                                                                        : candidate?.first_name?.[0]?.toUpperCase() || "?"}
                                                                </div>
                                                                {/* )} */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="twm-mid-content">
                                                        <div className="twm-candidates-tag">
                                                            <span>{t("Featured")}</span>
                                                        </div>
                                                        <h4>{`${candidate.first_name}`}</h4>
                                                        <p>{candidate.designation || "Worker"}</p>
                                                    </div>
                                                </div>
                                                <div className="twm-fot-content">
                                                    <div className="twm-left-info">
                                                        <p className="twm-candidate-address">
                                                            <i className="feather-map-pin" />
                                                            {candidate.country || t("Not specified")}
                                                        </p>
                                                        <NavLink to={publicUser.candidate.GRID.replace(":id", candidate.id)}>
                                                            <p className="twm-candidate-address">
                                                                <i className="feather-eye" />
                                                                {t("View")}
                                                            </p>
                                                        </NavLink>
                                                        <div className="twm-jobs-vacancies">
                                                            {candidate.salary || ""}
                                                            <span>{candidate.salary ? "/ Day" : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className="text-center m-b30">
                                <NavLink to={publicUser.candidate.LIST} className="site-button">
                                    {t("All Candidates")}
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* CANDIDATES END */}
            {/* ABOUT SECTION END */}
            <div className="section-full twm-contact-one p-t120" ref={formRef}>
                <div className="section-content">
                    <div className="container">
                        {/* CONTACT FORM*/}
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="contact-form-outer">
                                    {/* title="" START*/}
                                    <div className="section-head left wt-small-separator-outer">
                                        <h2 className="wt-title">{t("Recruit With Us")}:</h2>
                                        {/* <p>Feel free to contact us and we will get back to you as soon as we can.</p> */}
                                    </div>
                                    {/* title="" END*/}
                                    <form onSubmit={handleSubmit} className="cons-contact-form" method="post">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="nameInput">{t("Name")} :</label>
                                                    <input
                                                        id="nameInput"
                                                        name="Name"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Name"
                                                        value={formData.Name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="companyInput">{t("Company Name")} :</label>
                                                    <input
                                                        id="companyInput"
                                                        name="companyName"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Company Name"
                                                        value={formData.companyName}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="emailInput">{t("Email")} :</label>
                                                    <input
                                                        id="emailInput"
                                                        name="EmpEmail"
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                        value={formData.EmpEmail}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="contactInput">{t("Contact No")} :</label>
                                                    <input
                                                        id="contactInput"
                                                        name="EmpNumber"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Contact Number"
                                                        value={formData.EmpNumber}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="industryInput">{t("Industry")} :</label>
                                                    <input
                                                        id="industryInput"
                                                        name="Industry"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Industry of Required Candidate"
                                                        value={formData.Industry}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="jobtitleInput">{t("JobTitle")} :</label>
                                                    <input
                                                        id="jobtitleInput"
                                                        name="JobTitle"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Job Title of Required Candidate"
                                                        value={formData.JobTitle}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-3">
                                                    <label className="mb-2 font-medium text-gray-800">{t("Job Description Upload")}</label>
                                                    <div className="form-group mb-3 form-control">
                                                        <input
                                                            type="file"
                                                            name="file"
                                                            accept=".pdf"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-4">
                                                <HCaptcha
                                                    sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
                                                    onVerify={(token) => setCaptchaToken(token)}
                                                    ref={captchaRef}
                                                />
                                            </div>
                                            <div className="col-md-12 mt-3 mb-5">
                                                <button type="submit" className="site-button">{t("Submit Now")}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployerContactUs;